import { Classes } from '@blueprintjs/core';

/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var NS = Classes.getClassNamespace();
var DATEINPUT = "".concat(NS, "-dateinput");
var DATEINPUT_POPOVER = "".concat(DATEINPUT, "-popover");
var DATEPICKER = "".concat(NS, "-datepicker");
var DATEPICKER_CAPTION = "".concat(DATEPICKER, "-caption");
var DATEPICKER_DAY = "DayPicker-Day";
var DATEPICKER_DAY_WRAPPER = "".concat(DATEPICKER, "-day-wrapper");
var DATEPICKER_FOOTER = "".concat(DATEPICKER, "-footer");
var DATEPICKER_NAVBAR = "".concat(DATEPICKER, "-navbar");
var DATEPICKER_NAVBUTTON = "DayPicker-NavButton";
var DATEPICKER_TIMEPICKER_WRAPPER = "".concat(DATEPICKER, "-timepicker-wrapper");
var DATERANGEPICKER = "".concat(NS, "-daterangepicker");
var DATERANGEPICKER_CONTIGUOUS = "".concat(DATERANGEPICKER, "-contiguous");
var DATERANGEPICKER_SINGLE_MONTH = "".concat(DATERANGEPICKER, "-single-month");
var DATERANGEPICKER_SHORTCUTS = "".concat(DATERANGEPICKER, "-shortcuts");
var DATERANGEPICKER_TIMEPICKERS = "".concat(DATERANGEPICKER, "-timepickers");
var TIMEPICKER = "".concat(NS, "-timepicker");
var TIMEPICKER_ARROW_BUTTON = "".concat(TIMEPICKER, "-arrow-button");
var TIMEPICKER_ARROW_ROW = "".concat(TIMEPICKER, "-arrow-row");
var TIMEPICKER_DIVIDER_TEXT = "".concat(TIMEPICKER, "-divider-text");
var TIMEPICKER_HOUR = "".concat(TIMEPICKER, "-hour");
var TIMEPICKER_INPUT = "".concat(TIMEPICKER, "-input");
var TIMEPICKER_INPUT_ROW = "".concat(TIMEPICKER, "-input-row");
var TIMEPICKER_MILLISECOND = "".concat(TIMEPICKER, "-millisecond");
var TIMEPICKER_MINUTE = "".concat(TIMEPICKER, "-minute");
var TIMEPICKER_SECOND = "".concat(TIMEPICKER, "-second");
var TIMEPICKER_AMPM_SELECT = "".concat(TIMEPICKER, "-ampm-select");

export { DATEINPUT, DATEINPUT_POPOVER, DATEPICKER, DATEPICKER_CAPTION, DATEPICKER_DAY, DATEPICKER_DAY_WRAPPER, DATEPICKER_FOOTER, DATEPICKER_NAVBAR, DATEPICKER_NAVBUTTON, DATEPICKER_TIMEPICKER_WRAPPER, DATERANGEPICKER, DATERANGEPICKER_CONTIGUOUS, DATERANGEPICKER_SHORTCUTS, DATERANGEPICKER_SINGLE_MONTH, DATERANGEPICKER_TIMEPICKERS, TIMEPICKER, TIMEPICKER_AMPM_SELECT, TIMEPICKER_ARROW_BUTTON, TIMEPICKER_ARROW_ROW, TIMEPICKER_DIVIDER_TEXT, TIMEPICKER_HOUR, TIMEPICKER_INPUT, TIMEPICKER_INPUT_ROW, TIMEPICKER_MILLISECOND, TIMEPICKER_MINUTE, TIMEPICKER_SECOND };
//# sourceMappingURL=classes.js.map
